import {
  connectFirestoreEmulator,
  doc,
  type Firestore,
  getFirestore,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { initFirebase } from "..";
import { general, env } from "../../../Consts/config";
import { s400 } from "src/Consts/responses";

let firestorePromise: Promise<Firestore> | null = null;
let isFirestoreEmulatorConnected = false;

const getFirestoreInstance = async () => {
  if (!firestorePromise) {
    firestorePromise = initFirebase().then((app) => {
      const firestore = getFirestore(app);
      if (env.IS_LOCAL && !isFirestoreEmulatorConnected) {
        connectFirestoreEmulator(
          firestore,
          "localhost",
          parseInt(env.FIRESTORE_EMULATOR_PORT)
        );
        isFirestoreEmulatorConnected = true;
      }
      return firestore;
    });
  }
  return firestorePromise;
};

const getUserDocRef = async () => {
  const user = getAuth().currentUser;
  if (!user) {
    throw s400.USER__NOT_FOUND;
  }
  const firestore = await getFirestoreInstance();
  return doc(firestore, general.FIRESTORE_USERS_COLLECTIONS, user.uid);
};

const getNotificationsDocRef = async () => {
  const user = getAuth().currentUser;
  if (!user) {
    throw s400.USER__NOT_FOUND;
  }
  const firestore = await getFirestoreInstance();
  return doc(firestore, general.FIRESTORE_NOTIFICATIONS_COLLECTIONS, user.uid);
};

export { getUserDocRef, getNotificationsDocRef };
